import i18next from "src/i18n/config";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { ExpiredWrapper } from "@shared/ExpiredWrapper";

import { SidePanel } from "../shared/components/SidePanel/SidePanel";

import { DeviceTable } from "./components/Table/DeviceTable";

const DevicesPage = () => {
    return (
        <PageContainer fitViewport>
            <ExpiredWrapper>
                <DeviceTable />
            </ExpiredWrapper>
            <SidePanel />
        </PageContainer>
    );
};

export default withMetaDescription(DevicesPage, {
    title: i18next.t("pages:devicePage.metaTitle"),
});
